import axios from "axios";
import Cookies from "js-cookie";



const request = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 10000,
});


request.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {

        return Promise.reject(error);
    }
);


request.interceptors.response.use(
    (response) => {

        return response;
    },
    (error) => {


        // if(error.message === "timeout of 10000ms exceeded" || error.status === 500 ) {
        //     window.location.href = RouterPaths.ERRORFALLBACK;
        // }




        return Promise.reject(error);
    }
);

export default request;
